import { Icon16Cancel } from '@vkontakte/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { getMultiTariffMobileActiveTab } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import {
    duplicatesItem,
    familyAlbumsItem,
    familyItem,
    noadsItem,
    othersItem,
    unlimitedAutouploadItem,
    uploadItem,
} from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/Features.data';
import type { FeatureItem } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/Features.types';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

const withDisable = (item: FeatureItem, condition: boolean): FeatureItem => {
    return condition
        ? {
              ...item,
              type: 'disabled',
              iconBefore: <Icon16Cancel />,
          }
        : item;
};

export const useFeaturesList = (space: number): FeatureItem[] => {
    const activeTariffTab = useSelector(getMultiTariffMobileActiveTab);

    const disableConditionBySpace = space < SPACE_LIST.gb_256;

    // Собираем фичи в зависимости от таба и определяем значения если нужно
    if (activeTariffTab === ETabsName.basic) {
        return [
            withDisable(unlimitedAutouploadItem, disableConditionBySpace),
            withDisable(duplicatesItem, true),
            withDisable(noadsItem, true),
            withDisable(familyItem, true),
            withDisable(uploadItem, true),
            withDisable(othersItem, true),
        ];
    }

    if (activeTariffTab === ETabsName.advanced) {
        return [
            withDisable(unlimitedAutouploadItem, disableConditionBySpace),
            withDisable(duplicatesItem, disableConditionBySpace),
            noadsItem,
            uploadItem,
            othersItem,
        ];
    }

    if (activeTariffTab === ETabsName.family) {
        return [
            unlimitedAutouploadItem,
            {
                ...familyItem,
                type: 'highlighted',
            },
            familyAlbumsItem,
            noadsItem,
            withDisable(duplicatesItem, disableConditionBySpace),
            othersItem,
        ];
    }

    return [];
};
